/**
 * Dokumentweite Einstellungen: Design, Schutz und Status.
 *
 * Alle hier ausgelesenen Eigenschaften gehören zu WordApiDesktop 1.4 und stehen
 * damit nur in Word für Windows und Mac zur Verfügung – in Word im Web fehlen
 * sie vollständig. Die Funktionen liefern dort `null`.
 */

import { supportsWordApiDesktop } from "./capabilities";
import { isWordAvailable, WordUnavailableError } from "./document";

export interface DocumentSettings {
  /** Angezeigter Name des verwendeten Designs. */
  themeName: string | null;
  /** Art des Dokumentschutzes, z. B. "NoProtection", "AllowOnlyReading". */
  protectionType: string | null;
  /** Ist das Dokument als abgeschlossen gekennzeichnet? */
  isFinal: boolean | null;
}

export async function readDocumentSettings(): Promise<DocumentSettings | null> {
  if (!isWordAvailable()) throw new WordUnavailableError();
  if (!supportsWordApiDesktop("1.4")) return null;

  try {
    return await Word.run(async (context) => {
      const document = context.document;
      document.load("activeThemeDisplayName,protectionType,isFinal");
      await context.sync();

      return {
        themeName:
          typeof document.activeThemeDisplayName === "string"
            ? document.activeThemeDisplayName.trim()
            : null,
        protectionType:
          typeof document.protectionType === "string" ? document.protectionType : null,
        isFinal: typeof document.isFinal === "boolean" ? document.isFinal : null,
      };
    });
  } catch {
    return null;
  }
}

/** Ist irgendeine Form von Schutz aktiv? */
export function isProtected(settings: DocumentSettings): boolean {
  const type = settings.protectionType;
  return type !== null && type.toLowerCase() !== "noprotection";
}
